var React = require('react');
var ReactNative = require('react-native');

import Icon from './wrappers/ReUpIcon';

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
} = ReactNative;

var TransactionHistory = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      transactions : [],
    }
  },

  componentDidMount : function()
  {
    this.didUpdate();
  },

  dataDependencies : function()
  {
    return ["Transactions", "Users"];
  },

  didUpdate : function(data)
  {
    var transHis = this;
    this.props.appManager.getDataType("Transactions", function(data)
    {
      transHis.setState({transactions:data});
    })
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_POINTS_LEFT_STATEMENT");
    if( user[ModelConstants.Credit] <= 0 ) creditsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");

    var compiledTransactions = TransactionHistory.compiledTransactions(this.state.transactions, appManager);
    var filteredCompiledTransactions = [];
    for( var i = 0; i < compiledTransactions.length; i++ )
    {
      var transaction = compiledTransactions[i];
      var text = TransactionHistory.getCreditPointsText(transaction, appManager);
      if( text.pointsText == null && text.creditText == null && text.passText == null ) continue;
      filteredCompiledTransactions.push(transaction);
    }

    var offRowBackgroundColor = appManager.getColorForKey("GeneralTitleColor",0.05);
    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }

        <ReUpScrollView ref="ptr" bounces={true} responder={this} featureName={"TransactionHistory"}>
          <View style={[styles.instructionContainer, {backgroundColor: instructionColor}]}>
            <View style={{alignSelf:'center'}}>
              <ReUpText numberOfLines={3} appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor, width:this.state.layout.width - 80}]}>
                {creditsLeftStatement}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <ReUpIconButton type={3}
              appManager={appManager}
              featureData={this.props.featureData}
              appActions={this.props.appActions}
              />
          </View>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          {
            filteredCompiledTransactions.map(function(transaction, index)
            {
              var text = TransactionHistory.getCreditPointsText(transaction, appManager);
              if( text.pointsText == null && text.creditText == null && text.passText == null ) return <View key={index}/>;
              return (
                <View key={index}>
                  <View style={[styles.transactionRow,{backgroundColor:index%2==0?offRowBackgroundColor:'transparent'}]}>
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.dateText,{color:generalTitleColor}]}>{locManager.dateTime(text.timeStamp)}</ReUpText>
                    {
                      text.creditText == null ? null : <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>{text.creditText}</ReUpText>
                    }
                    {
                      text.pointsText == null ? null : <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>{text.pointsText}</ReUpText>
                    }
                    {
                      text.passText == null ? null : <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>{text.passText}</ReUpText>
                    }
                  </View>
                  <View style={styles.transactionDivider} />
                </View>
              )
            })
          }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  dateText: {
    opacity:.6,
  },
  transactionRow: {
    padding:10,
  },
  transactionDivider: {
    height:1,
    backgroundColor:'#DADADA'
  }
});

TransactionHistory.dataDependencies = ["Transactions", "Users"];
// TODO: should have users too
// TransactionHistory.dataDependencies = ["Transactions", "Users"];

TransactionHistory.getCreditPointsText = function(transaction, appManager)
{
  var locManager = appManager.getLocalizationManager();
  var creditTransaction = transaction.creditTransaction;
  var pointsTransaction = transaction.pointsTransaction;
  var passTransaction = transaction.passTransaction;
  var creditText = null;
  var pointsText = null;
  var passText = null;
  var dateText = null;
  var timeStamp = null;
  if( creditTransaction != null )
  {
    dateText = typeof creditTransaction.TimestampEpoch !== 'undefined' && creditTransaction.TimestampEpoch > 0 ? appManager.timeSince(creditTransaction.TimestampEpoch) : appManager.timeSince(creditTransaction.Timestamp)
    timeStamp = creditTransaction.Timestamp;
    var credit = parseFloat(creditTransaction['Credit']);
    if( credit == 0 )
    {

    }
    else if( credit < 0 )
    {
      if( creditTransaction["Source"] == "99" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(-credit)]);
      }
      else if( creditTransaction["Source"] == "6" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_SENT_GC_STATEMENT", [locManager.localizedDollars(-credit), "You sent a %0% gift card!"])
      }
      else
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT", [locManager.localizedDollars(-credit)]);
      }
    }
    else
    {
      if( creditTransaction["Source"] == "99" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(credit)]);
      }
      else if( creditTransaction["Source"] == "6" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_GC_STATEMENT", [locManager.localizedDollars(credit), "You received a %0% gift card!"])
      }
      else if( creditTransaction["Source"] == "11" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locManager.localizedDollars(credit)], "You transferred %0% from an old loyalty account!");
      }
      else
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_DEPOSITED_STATEMENT", [locManager.localizedDollars(credit)]);
      }
    }
  }

  if( pointsTransaction != null )
  {
    dateText = typeof pointsTransaction.TimestampEpoch !== 'undefined' && pointsTransaction.TimestampEpoch > 0 ? appManager.timeSince(pointsTransaction.TimestampEpoch) : appManager.timeSince(pointsTransaction.Timestamp)
    timeStamp = pointsTransaction.Timestamp;
    var points = parseInt(pointsTransaction['Points'])
    if( points == 0 )
    {

    }
    else if( points < 0 )
    {
      points = Math.abs(points)
      if( pointsTransaction["Source"] == "99" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_LOST_STATEMENT", [locManager.localizedPoints(points)]);
      }
      else if( pointsTransaction["Source"] == "6" )
      {
        
        pointsText = locManager.localizedStringForKeyAndParams("USER_SENT_POINTS_STATEMENT", [locManager.localizedPoints(points)], "You sent %0%!");

        pointsText = "";
      }
      else
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT", [locManager.localizedPoints(points)]);
      }
    }
    else
    {
      var locPoints = locManager.localizedPoints(points);
      if( pointsTransaction["Source"] == "99" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locPoints]);
      }
      else if( pointsTransaction["Source"] == "6" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_POINTS_STATEMENT", [locPoints], "You received %0%!");
      }
      else if( pointsTransaction["Source"] == "11" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locPoints], "You transferred %0% from an old loyalty account!");
      }
      else if( pointsTransaction["Source"] == "10" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_POINTS_FOR_REFERRAL", [locPoints] + "You earned %0% for a referral");
      }
      else
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT", [locPoints]);
      }
    }
  }

  if( passTransaction != null )
  {
    dateText = typeof passTransaction.TimestampEpoch !== 'undefined' && passTransaction.TimestampEpoch > 0 ? appManager.timeSince(passTransaction.TimestampEpoch) : appManager.timeSince(passTransaction.Timestamp)
    timeStamp = passTransaction.Timestamp;
    if( passTransaction.IsCredit == "1" )
    {
      passText = locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_PURCHASE", [passTransaction.PassQuantityRemaining, passTransaction.PassName, locManager.localizedDollars(passTransaction.Credit)], "You purchased %0% %1% for %2%!");
    }
    else
    {
      passText =  locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassName], "You redeemed one of the %0%.");
      if( passTransaction.PassQuantityRemaining > 0 ) passText += " " + locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassQuantityRemaining], "Only %0% are left!");
      else passText += " " + locManager.localizedStringForKey("PASS_TRANSACTION_NONE_ARE_LEFT", "None are left.");   
    }
  }

  return {creditText: creditText, pointsText: pointsText, passText: passText, dateText: dateText, timeStamp: timeStamp};
}

TransactionHistory.compiledTransactions = function(transactions, appManager)
{
  var timeThreshold = 2000;
  if( transactions == null ) return [];

  transactions = transactions.sort(function(a,b)
  {
    return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
  });
  var compiledTransactions = [];
  for( var i = 0; i < transactions.length; i++ )
  {
    var thisTrans = transactions[i];
    if( thisTrans.IsDeleted == '1' ) continue;
    var thisCreditTrans = null;
    var thisPointsTrans = null;
    var thisPassTrans = null;
    if( thisTrans.IsCredit == "1" )
    {
      if( typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0 )
      {
        thisPassTrans = thisTrans;
      }
      else
      {
        thisCreditTrans = thisTrans;
      }
    }
    else
    {
      if( typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0 )
      {
        thisPassTrans = thisTrans;
      }
      else
      {
        thisPointsTrans = thisTrans;
      }
    }

    if( i < (transactions.length-1) )
    {
      var nextTrans = transactions[i+1];
      if( nextTrans.IsDeleted == '1' ) continue;
      var thisTime = appManager.getTime(thisTrans.Timestamp);
      var nextTime = appManager.getTime(nextTrans.Timestamp);
      if( Math.abs(thisTime - nextTime) <= timeThreshold )
      {
        if( typeof nextTrans.PassID !== 'undefined' && nextTrans.PassID.length > 0 && thisPassTrans != null )
        {
          if( thisPassTrans.Credit < 0 && nextTrans.Credit > 0 )
          {
            thisPassTrans = nextTrans;
          }
          i++;
        }
        else if( nextTrans.IsCredit == "1" && thisCreditTrans == null )
        {
          thisCreditTrans = nextTrans;
          i++
        }
        else if( thisPointsTrans == null && nextTrans.IsCredit != "1" )
        {
          thisPointsTrans = nextTrans;
          i++
        }
      }
    }
    compiledTransactions.push({pointsTransaction:thisPointsTrans, creditTransaction:thisCreditTrans, passTransaction:thisPassTrans});
  }

  return compiledTransactions;
}

TransactionHistory.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var locManager = appActions._appManager.getLocalizationManager();
  var iconName = featureData.data.icon.replace("fa-", "")
  var cards = [];
  var transactions = data != null && typeof data !== 'undefined' && typeof data.Transactions !== 'undefined' && data.Transactions != null ? TransactionHistory.compiledTransactions(data.Transactions, appActions._appManager) : [];
  if( transactions.length <= 0 ) return [];
  var didSelect = function() {appActions.requestFeatureName("TransactionHistory")};
  var transactionData = [];
  var MAX_TRANSACTIONS = 3;
  var biggestTimeStamp = 0;
  for( var i = 0; i < transactions.length && i < MAX_TRANSACTIONS; i++ )
  {
    var thisData = [];
    var transaction = transactions[i];
    var pointsTransaction = transaction.pointsTransaction;
    var creditTransaction = transaction.creditTransaction;
    var passTransaction = transaction.passTransaction;

    if( passTransaction == null )
    {
      var date = transaction.pointsTransaction == null ? creditTransaction.Timestamp : pointsTransaction.Timestamp;
      thisData.push(locManager.localizedLongDate(date));
      var thisDateTime = appManager.getTime(date);
      if( thisDateTime > biggestTimeStamp )
      {
        biggestTimeStamp = thisDateTime;
      }

      if( pointsTransaction != null ) thisData.push(locManager.localizedPts(pointsTransaction.Points));
      else thisData.push(locManager.localizedPts(0));

      if( creditTransaction != null ) thisData.push(locManager.localizedDollars(creditTransaction.Credit));
      else thisData.push(locManager.localizedDollars(0));

      transactionData.push(thisData);
    }
  }

  if( transactionData.length <= 0 ) return [];

  if( transactions.length > MAX_TRANSACTIONS )
  {
    var moreLabel =locManager.localizedStringForKey("MORE_LABEL");
    transactionData.push(["","",moreLabel])
  }

  var sortOrder = (new Date()).getTime() - biggestTimeStamp;

  return [{
            didSelect : didSelect,
            title : featureData.data.title,
            columnData : transactionData,
            icon : iconName,
            cardType : 0,
            sortOrder : sortOrder
          }];
}

module.exports = TransactionHistory;



// WEBPACK FOOTER //
// ./src/TransactionHistory.js